module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_twitter-269aadb35eedb1c78f7d2ee04f480bc1.svg";